export default function Step3() {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 5.06836C21.7276 5.06836 25.1025 6.57961 27.5456 9.02271C29.9887 11.4658 31.5 14.8408 31.5 18.5684C31.5 22.296 29.9887 25.6709 27.5456 28.114C25.1025 30.5572 21.7276 32.0684 18 32.0684C14.2724 32.0684 10.8974 30.5572 8.45435 28.114C6.01125 25.6709 4.5 22.296 4.5 18.5684C4.5 14.8408 6.01125 11.4658 8.45435 9.02271C10.8974 6.57961 14.2724 5.06836 18 5.06836Z"
                stroke="#3F68E0"
                strokeWidth="1.26"
            />
            <path d="M18 11.0684V20.0684L23.25 17.0684" stroke="#3F68E0" strokeWidth="1.26" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
